import { Tag } from "./styles";

const TagColor = ({ color }: { color: string }) => {
  return <Tag color={color}></Tag>;
};
export default TagColor;
